import graphql from "babel-plugin-relay/macro";
import { commitMutation } from "react-relay";

const mutation = graphql`
  mutation rejectImportMutation($importPk: Int!, $comment: String!) {
    rejectImportDocument(importPk: $importPk, comment: $comment) {
      ok
      error {
        statusCode
      }
      redirectPath
    }
  }
`;

const rejectImport = (environment, variables, callback) => {
  commitMutation(environment, {
    mutation,
    variables,
    onCompleted: (response, errors) => {
      callback(response, errors);
    },
    onError: err => {
      throw new Error(err);
    }
  });
};

export default rejectImport;
